module.exports = __webpack_public_path__ + "img/public/SiteIcons/send-message-icon.svg?d43dce51";